import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "../App";
import AiTrustScoreAgent from "../pages/AiTrustScoreAgent";
import Metatags from "../Metatags";

export default function AppRouter() {
  return (
    <HelmetProvider>
      <Router>
        <Metatags />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/agenttrust" element={<AiTrustScoreAgent />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}
